import { cn } from '@/utils/cn';
import { Pressable, View } from 'react-native';
import { ChevronRight } from '../icons/ChevronRight';
import { Text } from './ui/text';
import { Lock } from '@/icons/Lock';

export function ListSection({
  title,
  children,
  modifier
}: {
  title: string;
  children: React.ReactNode;
  modifier?: 'danger';
}) {
  return (
    <View className="mx-2 mt-4">
      <View className="flex-row items-center justify-between py-2 pl-2 pr-4">
        <Text
          className={cn('font-medium', modifier === 'danger' && 'text-red-500')}
        >
          {title}
        </Text>
      </View>
      {children}
    </View>
  );
}

export function ListItem({
  title,
  value,
  isLast,
  isFirst,
  onPress,
  modifier
}: {
  title: string;
  value?: string | null;
  isLast?: boolean;
  isFirst?: boolean;
  onPress: () => void;
  modifier?: 'danger' | 'lock';
}) {
  return (
    <Pressable onPress={onPress}>
      <View
        className={cn(
          'flex w-full flex-row items-center justify-between bg-card px-2 py-2',
          isLast && 'rounded-b-md',
          !isLast && 'border-b border-gray-700',
          isFirst && 'rounded-t-md'
        )}
      >
        <View className="mr-2 flex flex-1 flex-row overflow-hidden">
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            className={cn(
              'flex-1 pl-2',
              modifier === 'danger' && 'text-red-500'
            )}
          >
            {title}
          </Text>

          {value && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              className="flex-1 pr-2 text-right text-gray-400"
            >
              {value}
            </Text>
          )}
        </View>
        {modifier === 'lock' ? (
          <Lock size={22} className="flex-shrink-0 text-gray-400" />
        ) : (
          <ChevronRight size={22} className="flex-shrink-0 text-gray-400" />
        )}
      </View>
    </Pressable>
  );
}
